module.exports = __webpack_public_path__ + "static/media/english.072a0b49.png";